import { useLocation } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useLazyGetDataQuery } from 'store/payment/service';
import { setPaymentData } from 'store/payment/slice';

const useLoadData = () => {
  const { paymentData } = useAppSelector((state) => state.payment);
  const location = useLocation();

  const [getData, { isLoading, isFetching }] = useLazyGetDataQuery();
  const dispatch = useAppDispatch();

  const loadData = async () => {
    const res = await getData({
      url: location.pathname,
      params: location.search,
    }).unwrap();

    dispatch(setPaymentData(res));

    return res;
  };

  return {
    loadData,
    isLoading: isFetching || isLoading,
    paymentData,
  };
};

export { useLoadData };
